import React from "react";
import { useUnit } from "../../context/UnitContext";
import { AVAILABLE_UNITS } from "../../utils/unitConversion";
import "./FilterPanel.css";
import StraightenRoundedIcon from "@mui/icons-material/StraightenRounded";

const FilterPanel = ({ selectedTimePeriod, onTimePeriodChange }) => {
  const { selectedUnit, setSelectedUnit } = useUnit();
  const timePeriods = [
    { value: "day", label: "Día" },
    { value: "week", label: "Semana" },
    { value: "month", label: "Mes" },
  ];

  return (
    <div className="ng-filter">
      <div className="ng-filter__tabs" role="tablist" aria-label="Periodo">
        {timePeriods.map((period) => (
          <button
            key={period.value}
            role="tab"
            type="button"
            aria-selected={selectedTimePeriod === period.value}
            className={`ng-filter__tab ${selectedTimePeriod === period.value ? "is-active" : ""}`}
            onClick={() => onTimePeriodChange(period.value)}
          >
            {period.label}
          </button>
        ))}
      </div>

      <div className="ng-filter__unit" title="Unidad">
        <StraightenRoundedIcon className="ng-filter__unit-icon" />
        <select
          aria-label="Unidad de medida"
          className="ng-filter__unit-select"
          value={selectedUnit}
          onChange={(e) => setSelectedUnit(e.target.value)}
        >
          {AVAILABLE_UNITS.map((unit) => (
            <option key={unit.value} value={unit.value}>
              {unit.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default FilterPanel;
